// extracted by mini-css-extract-plugin
export var avatarContainer = "_ed-0";
export var avatarTypingWave = "_ed-i";
export var gray = "_ed-f";
export var green = "_ed-c";
export var icon = "_ed-9";
export var image = "_ed-1";
export var lg = "_ed-6";
export var md = "_ed-5";
export var presenceDot = "_ed-b";
export var red = "_ed-d";
export var sm = "_ed-4";
export var status = "_ed-a";
export var typingDot = "_ed-h";
export var typingPill = "_ed-g";
export var xl = "_ed-7";
export var xs = "_ed-3";
export var xxl = "_ed-8";
export var xxs = "_ed-2";
export var yellow = "_ed-e";